<ng-container *ngIf="hoursFormArray && hoursFormArray.controls">
    <div *ngFor="let day of hoursFormArray.controls; let i = index"
        class="d-flex align-items-center justify-content-between mb-2 hours-wrapper" [ngClass]="{'show-day-toggles': showDayToggles}">
        <div class="d-flex align-items-center">
            <rosie-switch [ariaLabel]="getDayTranslationKey(day.get('day')?.value) | translate" *ngIf="showDayToggles" [control]="dayToggleControls[i]" class="toggle">
            </rosie-switch>
            <span class="day-label">{{ getDayTranslationKey(day.get('day')?.value) | translate }}</span>
        </div>
        <div class="d-flex gap-2" *ngIf="!showDayToggles || isDayEnabled(day)">
            <rosie-typeahead [control]="day.get('open')" [options]="businessHours" class="hour-typeahead"
                [customClass]="'select-full-arrow-sm'" [dataHook]="dataHook"
                [placeholderTranslationKey]="startTimePlaceholder"></rosie-typeahead>
            <rosie-typeahead [control]="day.get('close')" [options]="businessHours" class="hour-typeahead"
                [customClass]="'select-full-arrow-sm'" [dataHook]="dataHook"
                [placeholderTranslationKey]="endTimePlaceholder"></rosie-typeahead>
        </div>
    </div>
</ng-container>